module.exports = __webpack_public_path__ + "img/shopping-coupon.8d9c6f24.svg";